import React, { forwardRef } from 'react';

import { useTranslation } from 'react-i18next';

import BdsDivider from '../../../../../../shared/components/v3/Globals/BdsDivider/BdsDivider';
import { IHealthReport } from '../../../../../../shared/interfaces/reports';
import { TRANSLATIONS_REPORTS } from '../../../../../../shared/translations/reports';
import SectionAnchor from '../SectionAnchor/SectionAnchor';

import './CoverageData.scss';

export const CoverageData = forwardRef(
  ({ data, isMexico }: { data: IHealthReport; isMexico: boolean }, ref: React.Ref<HTMLDivElement>) => {
    const { t } = useTranslation();

    return (
      <>
        <div className="hr-coverage-header" ref={ref}>
          <SectionAnchor />
          <div className="health-report-section-title">{t(TRANSLATIONS_REPORTS.healthReport.coverage.title)}</div>
          <div className="health-report-description">{t(TRANSLATIONS_REPORTS.healthReport.coverage.description)}</div>
        </div>
        <div className="insurance-data">
          <div className="insurance-data-item">
            <div className="item-value">{data.insuredMembers}</div>
            <div className="item-label">
              {t(TRANSLATIONS_REPORTS.healthReport.coverage.employeesProtected, { count: data.insuredMembers })}
            </div>
          </div>
          <div className="insurance-data-item">
            <div className="item-value">{data.totalDependents}</div>
            <div className="item-label">
              {t(TRANSLATIONS_REPORTS.healthReport.coverage.dependentsProtected, { count: data.totalDependents })}
            </div>
          </div>
          {!isMexico && (
            <div className="insurance-data-item">
              <div className="item-value">{data.nonInsuredMembers}</div>
              <div className="item-label">
                {t(TRANSLATIONS_REPORTS.healthReport.coverage.employeesUnprotected, { count: data.nonInsuredMembers })}
              </div>
            </div>
          )}
        </div>
        <div className={`hr-coverage-divider ${isMexico ? 'mexico' : ''}`}>
          <BdsDivider size="s" color="high" />
        </div>
      </>
    );
  }
);

CoverageData.displayName = 'CoverageData';
export default CoverageData;
